import * as React from 'react'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'

const initCustomDropdowns = () => {
  document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
    if (dropdown.dataset.init) return
    dropdown.dataset.init = 'true'

    const trigger = dropdown.querySelector('.dropdown-trigger')
    const placeholder = dropdown.querySelector('.dropdown-placeholder')
    const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]')

    if (!trigger || !placeholder) return

    trigger.addEventListener('click', e => {
      e.stopPropagation()
      dropdown.classList.toggle('open')
    })

    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const selected = [...checkboxes]
          .filter(i => i.checked)
          .map(i => i.value)

        placeholder.textContent = selected.length
          ? selected.join(', ')
          : ''
      })
    })
  })

  // ⬇️ ÜKS globaalne outside-click
  if (!document.body.dataset.dropdownOutsideInit) {
    document.body.dataset.dropdownOutsideInit = 'true'

    document.addEventListener('click', e => {
      document.querySelectorAll('.custom-dropdown.open').forEach(dropdown => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('open')
        }
      })
    })
  }
}

const BasicModal = ({ items }) => {
  const [open, setOpen] = React.useState(false)


  React.useEffect(() => {
    const handleMailSent = (event) => {
      const cf7 = event.target;
      const wrapper = cf7.closest('.cf7-block');

      if (!wrapper) return;

      const thankYou = wrapper.querySelector('.thankyou-message');
      const intro = wrapper.querySelector('.modal-intro');

      if (thankYou) {
        cf7.style.display = 'none';

        if (intro) {
          intro.style.display = 'none';
        }

        thankYou.style.display = 'block';
      }
    };

    document.addEventListener('wpcf7mailsent', handleMailSent);

    return () => {
      document.removeEventListener('wpcf7mailsent', handleMailSent);
    };
  }, []);

  const handleOpen = () => {
    setOpen(true)

    setTimeout(() => {
      if (window.wpcf7) {
        document.querySelectorAll('.wpcf7 form').forEach(form => {
          window.wpcf7.init(form)
          window.wpcf7.reset(form)
        })
      }

      initCustomDropdowns()
    }, 0)
  }

  const handleClose = () => setOpen(false)

  return (
    <>
      <a
        onClick={handleOpen}
        className="primary-button lined-button whitespace-nowrap text-center text-gray-700 hover:text-bilbo-900 w-fit cursor-pointer"
      >
        {items.button}
      </a>

      <Modal open={open} onClose={handleClose}>
        <Fade in={open} timeout={300}>
          <div className="modalContainer">
            <div className="modalWindow">
              <header className="flex gap-10 flex-col">
                <div className="flex justify-end">
                  <span onClick={handleClose} className="close-button cursor-pointer">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                      <path
                        d="M24.6309 24.6299L0.630859 0.629883M24.6309 0.629883L0.630859 24.6299"
                        stroke="#1E3E43"
                        strokeWidth="1.26"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>

                <h4 className="h3-title mb-6">{items.header}</h4>
              </header>

              <div dangerouslySetInnerHTML={{ __html: items.content }} />
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  )
}

export default BasicModal
